// src/view/admin/did/components/StatsCard.jsx

import { Paper, Stack, Typography, Box, alpha } from "@mui/material";

export const StatsCard = ({ icon: Icon, label, value, color, trend }) => (
  <Paper
    elevation={0}
    sx={{
      display: "flex",
      justifyContent: "space-between",
      p: 2.5,
      borderRadius: 2.5,
      border: `1px solid ${alpha(color, 0.2)}`,
      bgcolor: alpha(color, 0.05),
      transition: "0.3s",
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: `0 8px 24px ${alpha(color, 0.15)}`,
        border: `1px solid ${alpha(color, 0.4)}`,
      },
    }}
  >
    <Box>
      <Stack direction="row" justifyContent="space-between" mb={1.5}>
        <Box
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: alpha(color, 0.15),
            display: "inline-flex",
          }}
        >
          <Icon size={22} color={color} />
        </Box>
        {trend && (
          <Typography
            variant="caption"
            sx={{
              px: 1,
              py: 0.5,
              borderRadius: 1,
              bgcolor: alpha(color, 0.1),
              color: color,
              fontWeight: 600,
            }}
          >
            {trend}
          </Typography>
        )}
      </Stack>

      <Typography variant="body2" color="text.secondary" fontWeight={500}>
        {label}
      </Typography>
    </Box>

    <Typography variant="h4" fontWeight={700} color={color}>
      {value}
    </Typography>
  </Paper>
);
